import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import {UserService} from '../../services/user.service';
import {cfgCaseProcedure} from '../ar/_models/ar.models';
import {CalendarCaseProcedureModel} from '../../models/appointments/calendar-case-procedure.model';
import {AppointmentDocumentDataModel} from '../../models/appointments/appointment-document-data.model';
import {DataAppointmentModel} from '../../models/appointments/data-appointment.model';
import {ToothUiManagerModel} from '../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import {OperatoryDataModel} from '../../models/clients/operatory-data.model';
import {DailyDetailModel} from '../../models/appointments/daily-detail.model';
import {WeeklyDetailDataModel} from '../../models/appointments/weekly-detail-data.model';
import {DoctorDataModel} from '../../models/doctors/doctor-data.model';
import {DataAppointmentWaitListModel, WaitListViewModel} from "../../models/appointments/dataAppointmentWaitList.model";
import {CaseTooth} from "../../main-interface/imaging/models/CaseTooth";

@Injectable({
  providedIn: 'root'
})
export class SchedulingService {
  res: string = '';

  constructor(private http: HttpClient) {
  }

  // getSequentialGuid() {
  //   return this.http.get<any>('/api/calendar/getNonSequentialGuid');
  // }

  addAppointment(appointmentObj: any, teeth: ToothUiManagerModel[]): any {
    let url: string;
    const method: string = 'calendar/SaveAppointment';

    url = environment.TDOurl + method ;

    return this.http.post<any>(url, {appointment: appointmentObj, teeth});
  }

  saveWaitListAppointment(waitList: DataAppointmentWaitListModel) {
    return this.http.post<DataAppointmentWaitListModel>('api/calendar/saveWaitListAppointment', waitList);
  }

  getWaitList(){
    return this.http.get<boolean>('api/calendar/showWaitList');
  }

  getAppointmentWaitList(){
    return this.http.get<WaitListViewModel[]>('api/calendar/getAppointmentWaitList');
  }

  rescheduleAppointment(startApp: string, AppointmentId: string, Resource_OperatoryId: string) {
    const params = new HttpParams()
      .set('startApp', startApp)
      .set('AppointmentId', AppointmentId)
      .set('Resource_OperatoryId', Resource_OperatoryId);

    return this.http.get<DataAppointmentModel>('api/calendar/rescheduleAppointmentfromOrigin', { params });
  }

  saveAppointment(appointment: DataAppointmentModel) {
    return this.http.post<DataAppointmentModel>('api/calendar/save-appointment', appointment);
  }

  getAppointmentsMinimum(locid: string, dateRange: string ): Observable<DataAppointmentModel[]> {
    let url: string;
    const method: string = 'calendar/get-appointments-minimum/' + locid + '/' + dateRange;

    url = environment.TDOurl + method;

    return this.http.get<DataAppointmentModel[]>(url);
  }

  getAppointments(locid: string[], dateRange: string ): Observable<DataAppointmentModel[]> {
    let url: string;
    const method: string = 'calendar/GetAppointmentsList/' + dateRange;

    url = environment.TDOurl + method;

    return this.http.post<DataAppointmentModel[]>(url, locid);
  }

  getDailyDetail(dateRange: string, selectedDoctors: string[], locids: string[]) {
    return this.http.post<DailyDetailModel>(environment.TDOurl + `calendar/get-daily-details/${dateRange}`, {locids, selectedDoctors});
  }

  getWeeklyDetail(selectedDate: string, selectedDoctors: string[], locids: string[]) {
    return this.http.post<WeeklyDetailDataModel>(`api/calenmdar/get-weekly-details/${selectedDate}`, {locids, selectedDoctors});
  }

  /*getAppointmentStatusById(appointmentID: string): Observable<any[]> {
    return this.http.get<any[]>(`/api/appointment/getAppointmentStatusById/${appointmentID}`, UserService.authorizationHeaderObject);
  }*/

  postSearchForPatient(searchFor: string): Observable<any[]> {
    let url: string;
    const method: string = 'calendar/PostSearchForPatient';

    url = environment.TDOurl + method;

    const payload = {
      searchText: searchFor
    };

    return this.http.post<any[]>(url, payload, UserService.authorizationHeaderObject);
  }

  handleError(error) {
    console.error('scheduling error: ', error.message);
  }

  getValidValueItems(validValueName: string): Observable<any[]> {
    let url: string;
    const method: string = 'calendar/GetValidValues';
    url = environment.TDOurl + method + '/' + validValueName;
    return this.http.get<any[]>(url, UserService.authorizationHeaderObject);
  }

  getProcedureGroup(procedureGroupID: string): Observable<any[]> {
    return this.http.get<any[]>(`/api/procedureGroup/${procedureGroupID}`, UserService.authorizationHeaderObject);
  }

  getProcedures(): Observable<any[]> {
    let url: string;
    const method: string = 'calendar/GetProcedures';
    url = environment.TDOurl + method;
    return this.http.get<any[]>(url, UserService.authorizationHeaderObject);
  }

  getCaseProcedures(patientCaseId: string): Observable<CalendarCaseProcedureModel[]> {
    return this.http.get<CalendarCaseProcedureModel[]>(`api/calendar/get-case-procedures/${patientCaseId}`);
  }

  getOperatories(locid: string): Observable<any[]> {
    let url: string;
    const method: string = 'calendar/GetOperatories';
    url = environment.TDOurl + method + '/' + locid;
    return this.http.get<any[]>(url, UserService.authorizationHeaderObject);
  }

  getOperatoriesV2(locids: number[]) {
    return this.http.post<OperatoryDataModel[]>(`api/calendar/get-operatories`, locids);
  }

  getDocuments(appointmentId: string): Observable<AppointmentDocumentDataModel[]> {
    return this.http.get<AppointmentDocumentDataModel[]>(`api/appointment/get-documents/${appointmentId}`);
  }

  registerDocuments(models: AppointmentDocumentDataModel[]) {
    return this.http.post<AppointmentDocumentDataModel[]>('api/appointment/register-documents', models);
  }

  checkPatientIn(appointmentId: string) {
    return this.http.get<void>(`api/appointment/check-in/${appointmentId}`);
  }

  getCheckOutInformation(patientId: string): Observable<any[]> {
    return this.http.get<any[]>(`api/appointment/get-check-out-Information/${patientId}`);
  }

  getAppointmentIdByPatientId(patientId: string): Observable<DataAppointmentModel> {
    return this.http.get<DataAppointmentModel>(`api/appointment/getAppointmentIdByPatientId/${patientId}`);
  }

  getAppointmentsByCase(patientCaseId: string) {
    return this.http.get<DataAppointmentModel[]>(`api/appointment/get-appointments-by-case/${patientCaseId}`);
  }

  getAllPatientAppointments(currentPatient: string) {
    return this.http.get<DataAppointmentModel[]>(`api/appointment/get-all-patient-appointments/${currentPatient}`);
  }

  reserveAppointmentSlot(reserve: DataAppointmentModel) {
    return this.http.post<DataAppointmentModel>(`api/calendar/reserve-appointment-slot`, reserve);
  }

  reserveAdditionalOperatories(AppointmentId: string, newOpIds: string[]) {
    return this.http.post<DataAppointmentModel>(`api/calendar/reserve-additional-operatories/${AppointmentId}`, newOpIds);
  }

  deleteAppointment(AppointmentId: string) {
    return this.http.get<void>(`api/calendar/delete-appointment/${AppointmentId}`);
  }

  cancelAppointment(AppointmentId) {
    return this.http.get<DataAppointmentModel>(`api/calendar/cancel-appointment/${AppointmentId}`);
  }

  SetSeatedStatus(PatientCaseId: string) {
    return this.http.get<DataAppointmentModel>(`/api/calendar/set-seated-status/ ${PatientCaseId}`);
  }
}

